// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { TerceraComboBox } from "./TerceraComboBox.js";

export let TerceraWidthComboBox = TerceraComboBox.extend({
    data: function ()
    {
        return {
            showLastValue: true
        };
    }
});

TerceraWidthComboBox.prototype.getType = function () { return 'TerceraWidthComboBox' };

TerceraWidthComboBox.prototype.oninit = function ()
{
    TerceraComboBox.prototype.oninit.apply(this);
    var widthItems = [];
    for (var i = 0; i < 10; i++)
    {
        var value = i + 1;
        widthItems.push({           
            style: "js-WidthStyle-" + value + 'px',
            text: value + 'px',
            value: value
        });
    }
    this.set({ items:widthItems, listWidth:135, useImageView: true, imagewidth: 90, updateComboBoxClass: 'upClassWidthComboBox' });
};